import { useEffect } from "react";
import useCallSocket from "./hooks/useCallSocket";
import IncomingCall from "./IncomingCall";
import "./CallDashboard.css";

export default function CallDashboard({ businessNumber }) {
  const call = useCallSocket(businessNumber);
  
  
  return (
    <div className="call-dashboard">
      <div style={{ position: "relative" }}>

        {/* Show incoming call controls */}
        {(call?.status === "connect" || call?.status === "accept") && <IncomingCall call={call} />}

      </div>
    </div>
  );
}
